/**
 * TEMPORARY speech diagnostics (Preview / development only).
 *
 * Off by default. Turn on by opening CrewPilot with `?speechdebug=1` (remembered for the tab's
 * session; `?speechdebug=0` turns it off). When on, the voice screens show a read-only log of
 * every recognition event — sequence, resultIndex, results.length and each result's index,
 * isFinal and transcript — that the person can copy. Nothing is sent anywhere, and no audio is
 * touched: the log lives in memory in the page only.
 */
export const SPEECH_MODEL_VERSION = "shared-dictation final-results-only";
const KEY = "cp_speech_debug";

export function isSpeechDebugEnabled() {
  try {
    if (typeof window === "undefined") return false;
    const flag = new URL(window.location.href).searchParams.get("speechdebug");
    if (flag === "1") window.sessionStorage.setItem(KEY, "1");
    if (flag === "0") window.sessionStorage.removeItem(KEY);
    return window.sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/** Plain-text line describing one SpeechRecognitionEvent exactly as the browser delivered it. */
export function describeSpeechEvent(seq, startedAt, event, appended) {
  const results = event?.results ? Array.from(event.results) : [];
  return JSON.stringify({
    n: seq,
    t: Math.round(((typeof performance !== "undefined" ? performance.now() : Date.now()) - startedAt)),
    resultIndex: event?.resultIndex,
    length: results.length,
    results: results.map((result, index) => ({
      i: index,
      isFinal: Boolean(result?.isFinal),
      alts: result?.length,
      transcript: result?.[0]?.transcript ?? null,
    })),
    appended,
  });
}

export function deviceSummary() {
  const nav = typeof navigator !== "undefined" ? navigator : {};
  return `model=${SPEECH_MODEL_VERSION} ua=${nav.userAgent || "?"}`;
}
